<template>
  <sModal
    :closable="false"
    :mask-closable="false"
    :show-modal="false"
    :title="$t('Tenders.EditTenderLot')"
    :value="showModal">
    <template #activator>
      <sButton
        data-qa="btn-added-lot"
        :disabled="disabled"
        icon="edit"
        type="text"
        @click="openModal">
        {{ $t('Tenders.EditTenderLot') }}
      </sButton>
    </template>
    <div>
      <sForm
        ref="lotGroupForm"
        label-position="top"
        label-width="120px"
        :model="groupValue"
        :rules="rules">
        <sFormItem
          :label="$t('Common.Name')"
          prop="title">
          <sInput
            data-qa="input-lot-title"
            :value.sync="groupValue.title"/>
        </sFormItem>
        <sFormItem
          :label="$t('Common.Description')"
          prop="description">
          <sInput
            data-qa="input-lot-description"
            rows="4"
            show-word-limit
            type="textarea"
            :value.sync="groupValue.description"/>
        </sFormItem>
      </sForm>
    </div>
    <div
      key="footer"
      slot="footer">
      <sButton
        data-qa="btn-apply"
        @click="sendResult">
        {{ $t('Common.Save') }}
      </sButton>
      <sButton
        data-qa="btn-close"
        type="text"
        @click="showModal = false">
        {{ $t('Common.Close') }}
      </sButton>
    </div>
  </sModal>
</template>
<script>
export default {
  name: 'EditLotGroupProps',
  data() {
    return {
      showModal: false,
      groupValue: {}
    }
  },
  methods: {
    openModal() {
      this.groupValue = { ...this.group }
      this.showModal = true
    },
    sendResult() {
      this.$refs.lotGroupForm.validate(async (valid) => {
        if (valid) {
          this.$emit('update:group', this.groupValue)
          this.showModal = false
        }
      })
    }
  },
  props: {
    group: {
      type: Object,
      required: true
    },
    rules: {
      type: Object,
      default: () => ({})
    },
    disabled: Boolean
  },
}
</script>